import { render } from "./TablePrompt.vue?vue&type=template&id=b8440ac2&ts=true"
import script from "./TablePrompt.ts?vue&type=script&lang=ts&external"
export * from "./TablePrompt.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__